import Http from "./http";

export const deleteFileAPI = (payload) => {
    return Http.post("file/delete", payload);
};
